module.exports = __webpack_public_path__ + "0a32a80243e05284a5d741c5dc093f31.woff2";